(function () {
    'use strict';

    angular.module("imApp").factory("listDatasService", ['$ihttp', function ($ihttp) {
        let service = {
            listListDatas: function (parms) {
                return $ihttp.post({
                    method: 2718,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
